import { StateCreator } from "zustand";

import { GlobalStoreStateType, ThreadSliceType } from "@/state/@types";

export const createThreadSlice: StateCreator<
  GlobalStoreStateType,
  [],
  [],
  ThreadSliceType
> = (set, get) => ({
  // Initial state
  activeMessageIndex: 0,
  activeMessageContext: [],
  isSendingMessage: false,
  composerDraft: null,
  threadDrafts: {},
  isPageContextEnabled: true,
  // Actions
  setActiveMessageIndex: (index) => set({ activeMessageIndex: index }),
  setActiveMessageContext: (context) => set({ activeMessageContext: context }),
  setIsSendingMessage: (isSending) => set({ isSendingMessage: isSending }),
  setComposerDraft: (draft) => set({ composerDraft: draft }),
  setThreadDraft: (tabId, draft) => {
    const { [tabId]: _previous, ...rest } = get().threadDrafts;
    if (!draft && _previous === undefined) return;
    set({ threadDrafts: draft ? { ...rest, [tabId]: draft } : rest });
  },
  setIsPageContextEnabled: (isEnabled) =>
    set({ isPageContextEnabled: isEnabled }),
});
